let refCount = 0;
let wheelHandler = null;

function setPopstateMeta(state) {
  let meta = document.head.querySelector('meta[name="popstate"]');
  if (!meta) {
    meta = document.createElement("meta");
    meta.name = "popstate";
    document.head.appendChild(meta);
  }
  meta.setAttribute("content", state);
}

function preventBackWheel(e) {
  const { deltaX, deltaY } = e;
  if (!deltaX || Math.abs(deltaX) <= Math.abs(deltaY)) return;

  let node = e.target;
  while (node && node !== document.documentElement) {
    if (node.nodeType !== 1) {
      node = node.parentElement;
      continue;
    }
    const { overflowX } = window.getComputedStyle(node);
    const scrollable =
      ["auto", "scroll", "overlay"].includes(overflowX) &&
      node.scrollWidth > node.clientWidth;
    if (scrollable) {
      const atLeft = node.scrollLeft <= 0;
      const atRight =
        node.scrollLeft + node.clientWidth >= node.scrollWidth - 1;
      if ((deltaX < 0 && !atLeft) || (deltaX > 0 && !atRight)) return;
    }
    node = node.parentElement;
  }
  e.preventDefault();
}

export function enableStopBack() {
  refCount += 1;
  if (refCount > 1) return;

  if (window.history?.pushState) {
    history.pushState(null, "", document.URL);
  }
  setPopstateMeta("block");
  document.documentElement.classList.add("prevent-back");

  wheelHandler = preventBackWheel;
  document.addEventListener("wheel", wheelHandler, {
    passive: false,
    capture: true,
  });
}

export function releaseStopBack() {
  refCount = Math.max(0, refCount - 1);
  if (refCount > 0) return;

  setPopstateMeta("default");
  document.documentElement.classList.remove("prevent-back");

  if (wheelHandler) {
    document.removeEventListener("wheel", wheelHandler, { capture: true });
    wheelHandler = null;
  }
}
